/**
 * 文件相关接口
 */
import request from '../utils/axios'

//获取App版本列表
export function GetAppLis(params) {
  return request({
    url: `/File/GetAppLis`,
    method: "post",
		data:params
  })
}

// 删除App版本
export function DeleteApp(id) {
  return request({
    url: `/File/DeleteApp?id=${id}`,
    method: "get"
  })
}

// 下载模板
export function DownFiles(params) {
  return request({
    url: `/File/DownFiles?type=${params.type}&token=${params.token}&isWorker=${params.isWorker}`,
    method: "get",
		responseType:'blob'
  })
}

// 获取文件华为云上传链接
export function GetFileOBSUploadUrl(params) {
  return request({
    url: `/File/GetFileOBSUploadUrl`,
    method: "post",
		data:params
  })
}